'use client';

import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { useShallow } from 'zustand/shallow';
import { useOffersFilterStore } from '../Context';
import type { OffersFilterStoreState } from '../types';
import { getFilteredIds, getSortedIds, sortIds } from '../utils/cardOrderingUtils';
export function useCardOrdering(allOfferIds, featuredSequence, sequenceKey) {
  const $ = _c(14);
  const {
    areFiltersEnabled,
    preComputedFilterOfferIds,
    appliedFilters: t0,
    isLoading
  } = useOffersFilterStore(useShallow(_temp));
  const {
    creditRangeFilter,
    issuerFilter,
    cardFeatureFilter,
    sortBy
  } = t0;
  const useFilteredOfferOrdering = areFiltersEnabled && sequenceKey === "productCards";
  let t1;
  bb0: {
    if (!useFilteredOfferOrdering) {
      let t2;
      if ($[0] !== allOfferIds || $[1] !== featuredSequence) {
        t2 = sortIds(allOfferIds, featuredSequence);
        $[0] = allOfferIds;
        $[1] = featuredSequence;
        $[2] = t2;
      } else {
        t2 = $[2];
      }
      t1 = t2;
      break bb0;
    }
    let t2;
    if ($[3] !== allOfferIds || $[4] !== cardFeatureFilter || $[5] !== creditRangeFilter || $[6] !== featuredSequence || $[7] !== issuerFilter || $[8] !== preComputedFilterOfferIds || $[9] !== sortBy) {
      const filteredIds = getFilteredIds({
        allOfferIds,
        creditRangeFilter,
        issuerFilter,
        preComputedFilterOfferIds,
        cardFeatureFilter
      });
      t2 = getSortedIds({
        filteredIds,
        featuredSequence,
        preComputedFilterOfferIds,
        sortBy
      });
      $[3] = allOfferIds;
      $[4] = cardFeatureFilter;
      $[5] = creditRangeFilter;
      $[6] = featuredSequence;
      $[7] = issuerFilter;
      $[8] = preComputedFilterOfferIds;
      $[9] = sortBy;
      $[10] = t2;
    } else {
      t2 = $[10];
    }
    t1 = t2;
  }
  const orderedIds = t1;
  const t2 = sequenceKey === "productCards" ? isLoading : false;
  let t3;
  if ($[11] !== orderedIds || $[12] !== t2) {
    t3 = {
      orderedIds,
      isLoading: t2
    };
    $[11] = orderedIds;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
}
function _temp(state) {
  return {
    areFiltersEnabled: state.areFiltersEnabled,
    preComputedFilterOfferIds: state.preComputedFilterOfferIds,
    appliedFilters: state.appliedFilters,
    isLoading: state.isLoading
  };
}